import * as React from "react";
import PropTypes from "prop-types";

import "./styles.css";

export const BigCheckbox = ({ checked, setChecked, label, note }) => (
  <div styleName="container d-flex" onClick={() => setChecked(!checked)}>
    <div>
      <div styleName="checkbox">
        <i styleName={!checked && "invisible"} className={"fa fa-check"} />
      </div>
    </div>
    <div styleName="flex-grow-1">
      <span styleName="label">{label}</span>
      {note && <span styleName="note">{note}</span>}
    </div>
  </div>
);

BigCheckbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  setChecked: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  note: PropTypes.string
};

export default BigCheckbox;
